import type { SVGProps } from "react";

type OnboardingAgentSendPlaneIconProps = SVGProps<SVGSVGElement> & { fill: string };

export const OnboardingAgentSendPlaneIcon = ({ fill, ...rest }: OnboardingAgentSendPlaneIconProps) => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        focusable="false"
        {...rest}
    >
        <path
            fill={fill}
            d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
        />
    </svg>
);
